import { getAttachmentBadgeCategory, getFileExtensionLabel } from './attachmentBadgeCategory';
import { EventIcon, PollIcon, ViewListIcon } from '@/components/ui/Icons';
import './AttachmentCard.css';
import './AttachmentFileBadge.css';

export type AttachmentFileBadgeSize = 'md' | 'sm';
export type AttachmentBadgeKind = 'file' | 'project' | 'session' | 'planner';

type Props = {
  fileName: string;
  kind?: AttachmentBadgeKind;
  size?: AttachmentFileBadgeSize;
  className?: string;
};

/** Только бейдж файла из AttachmentCard (без карточки и ссылки). */
export function AttachmentFileBadge({ fileName, kind = 'file', size = 'md', className }: Props) {
  const safeName = fileName?.trim() || 'file';
  const ext = getFileExtensionLabel(safeName) || 'FILE';
  const cat = getAttachmentBadgeCategory(safeName);
  const sizeClass = size === 'sm' ? 'attachmentFileBadge_size_sm' : 'attachmentFileBadge_size_md';
  const iconSize = size === 'sm' ? 13 : 22;

  const icon =
    kind === 'project' ? (
      <ViewListIcon size={iconSize} className="attachmentCard__badgeIcon" />
    ) : kind === 'session' ? (
      <EventIcon size={iconSize} className="attachmentCard__badgeIcon" />
    ) : kind === 'planner' ? (
      <PollIcon size={iconSize} className="attachmentCard__badgeIcon" />
    ) : null;

  return (
    <div
      className={['attachmentFileBadge', sizeClass, className].filter(Boolean).join(' ')}
      aria-hidden
    >
      <div className="attachmentCard__badgeCol">
        <span
          className={`attachmentCard__badge attachmentCard__badge_kind_${kind}`}
          data-badge-cat={kind === 'file' ? cat : undefined}
        >
          {icon ?? <span className="attachmentCard__badgeExt">{ext}</span>}
        </span>
      </div>
    </div>
  );
}
